export default __webpack_public_path__ + "static/sputnik-11689ff38f6916d02d92bd67210383b9.jpg";